import { useEffect, useState } from 'react';

import { gql } from './api';

const ME_QUERY = `query Me { me { sub name username access { platform crm } } }`;
/** What an admin BFF that predates the access model can answer. */
const LEGACY_ME_QUERY = `query Me { me { sub name username } }`;

/**
 * Who is signed in, and which halves of the panel they may use.
 *
 * `me` used to be chrome only — the name on the rail — and its failure was
 * swallowed. It now also carries `access { platform crm }`, which the nav and
 * the route guards are built from, so it has a status:
 *
 *   'loading'  nothing is known yet; routes must not render (a platform screen
 *              mounted for a CRM-only user would fire a query the BFF refuses
 *              with FORBIDDEN, and that takes the whole panel away)
 *   'ready'    `me` answered
 *   'error'    `me` failed. The name is still chrome and the failure is not
 *              surfaced; `accessOf` falls back to the panel as it was before
 *              the CRM half existed (platform only).
 *
 * A BFF deployed BEFORE this client answers the new query with a validation
 * error; the legacy shape is asked for then, so the rail keeps its name while
 * the deployments catch up.
 */
export default function useMe() {
  const [state, setState] = useState({ me: null, status: 'loading' });

  useEffect(() => {
    let live = true;
    const settle = (next) => { if (live) setState(next); };
    gql(ME_QUERY)
      .then((d) => settle({ me: d?.me || null, status: d?.me ? 'ready' : 'error' }))
      .catch((err) => {
        if (err?.code !== 'GRAPHQL_VALIDATION_FAILED') {
          settle({ me: null, status: 'error' });
          return;
        }
        gql(LEGACY_ME_QUERY)
          .then((d) => settle({ me: d?.me ? { ...d.me, access: null } : null, status: 'error' }))
          .catch(() => settle({ me: null, status: 'error' }));
      });
    return () => { live = false; };
  }, []);

  return state;
}
